import styled from '@emotion/styled'

export const Scrollable = styled.div`
  align-items: center;
  background: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;

  @media (max-width: 768px) {
    padding-bottom: 6rem;
  }
`
